import React, { FunctionComponent, useCallback } from 'react'
import cn from 'classnames'
import { MktuClassWord } from '@/services/Api/generated'

import styles from './WordOption.module.scss'
import { Icon } from '@/icons'

interface WordOptionProps {
  word: MktuClassWord
  isSelected?: boolean
  onSelect?: (word: MktuClassWord) => void
}
export const WordOption: FunctionComponent<WordOptionProps> = ({
  word,
  isSelected = false,
  onSelect,
}) => {
  const click = useCallback(() => {
    onSelect(word)
  }, [word, onSelect])

  return (
    <button
      className={cn(styles.container, { [styles.isSelected]: isSelected })}
      onClick={click}
    >
      <div className={styles.left}>
        <div className={styles.classNumber}>{word.classNumber}</div>
        {word.word}
        {word.isNice ? <span className={styles.charNica}>N</span> : null}
      </div>

      <div className={styles.iconWrap}>
        <Icon name="check" className={styles.iconCheck} />
      </div>
    </button>
  )
}
